import { useCallback } from 'react';
import { useApi } from '@hooks/services/api';

export const useSiteBannerService = () => {
    const { apiRequest } = useApi();

    const getActiveSiteBanner = useCallback(async (path) => {
        if (typeof path !== 'string' || !path.startsWith('/app/')) {
            throw new Error('A valid /app path is required');
        }
        const response = await apiRequest('/site-banners/active', 'GET', null, {
            params: { path }
        });
        return response.data.banner;
    }, [apiRequest]);

    const dismissSiteBanner = useCallback(async (bannerId) => {
        if (!Number.isInteger(bannerId) || bannerId < 1) {
            throw new Error('A valid banner id is required');
        }
        const response = await apiRequest(`/site-banners/${bannerId}/dismiss`, 'POST');
        return response.data;
    }, [apiRequest]);

    return {
        getActiveSiteBanner,
        dismissSiteBanner
    };
};

export default useSiteBannerService;
